<div class="mr-xsmall-b" *ngIf="componentCase">
  <h1 class="nordic-blue-900-text mr-xsmall-b ms-clear-t font-heading-2" data-hj-suppress>
    {{ componentCase.categoryKey | finLocalization }}
  </h1>
  <div class="font-body-1 regular-type">
    {{ 'SERVICE_FORMS.CSServiceForms.retrieveFeedback.caseNumber.label' | finLocalization }}
    <span class="font-body-1 medium-type" data-hj-suppress>{{ componentCase.caseId }}</span>
  </div>
  <div class="font-body-1 regular-type">
    {{ 'SERVICE_FORMS.CSServiceForms.retrieveFeedback.chatter.caseStatusText' | finLocalization }}
    <span class="font-body-1 medium-type" data-hj-suppress>{{
      'SERVICE_FORMS.CSServiceForms.retrieveFeedback.chatter.status.' + componentCase.status | finLocalization
    }}</span>
  </div>
</div>

<div class="grid-col grid-col-12 no-gutters">
  <div class="rounded-large white-bg border col-1-12 md-col-1-8 mr-medium-b">
    <div class="pr-small">
      <div class="flex flex--space-between mr-small-b">
        <h3 class="font-body-1 nordic-blue-900-text">
          {{ 'SERVICE_FORMS.CSServiceForms.retrieveFeedback.chatter.feedbackSubmitted' | finLocalization }}
        </h3>
        <time
          class="font-body-1 regular-type nordic-blue-900-text"
          [dateTime]="componentCase.creationDate"
          data-hj-suppress
          >{{ componentCase.creationDate | finDateFormat: 'DATE_WITH_TIME' : true }}</time
        >
      </div>
      <div class="font-body-1 nordic-blue-900-text medium-type" data-hj-suppress>
        {{ componentCase.categoryKey | finLocalization }}
      </div>
      <div class="font-body-1 nordic-blue-900-text">
        {{ 'SERVICE_FORMS.CSServiceForms.retrieveFeedback.chatter.emailSent' | finLocalization }}
      </div>
    </div>
    <div class="messages">
      <div
        *ngFor="
          let message of componentCase.messages
            | slice
              : (componentCase.messages.length < 3 ? 0 : componentCase.messages.length - messageAmount)
              : componentCase.messages.length;
          let first = first;
          let index = index
        "
        class="message-container relative border-top"
        [class.teaser]="first && componentCase.messages.length > messageAmount"
        [class.pr-small-t]="index === 1 && componentCase.messages.length > messageAmount"
      >
        <div class="message pr-small relative overflow-hidden">
          <div class="flex flex--space-between mr-small-b">
            <h3 class="font-body-1 nordic-blue-900-text" data-hj-suppress>
              {{
                message.creator === 'customer'
                  ? componentCase.customer?.firstname + ' ' + componentCase.customer?.lastname
                  : message.creator
              }}
            </h3>
            <time
              class="font-body-1 regular-type nordic-blue-900-text"
              [dateTime]="message.creationDate"
              data-hj-suppress
              >{{ message.creationDate | finDateFormat: 'DATE_WITH_TIME' : true }}</time
            >
          </div>
          <div class="font-body-1 nordic-blue-900-text" data-hj-suppress [innerHTML]="message.content"></div>
          <div *ngIf="isNewDownloadAttachmentFlowEnabled">
            <a
              download
              rel="noopener noreferrer"
              class="block font-body-1 nordic-blue-900-text pr-xxsmall-t"
              href="javascript:void(0)"
              (click)="downloadAttachment(attachment)"
              *ngFor="let attachment of message.attachments"
              data-hj-suppress
            >
              {{ attachment.fileName }}
            </a>
          </div>
          <div *ngIf="!isNewDownloadAttachmentFlowEnabled">
            <a
              download
              rel="noopener noreferrer"
              target="_blank"
              class="block font-body-1 nordic-blue-900-text pr-xxsmall-t"
              [attr.href]="attachmentBaseUrl + attachment.attachmentId"
              *ngFor="let attachment of message.attachments"
              data-hj-suppress
              >{{ attachment.fileName }}
            </a>
          </div>
        </div>
        <div
          *ngIf="first"
          class="fill absolute z1 align-center show-messages"
          [ngClass]="{ 'is-vishidden no-visibility': componentCase.messages.length <= messageAmount }"
        >
          <fcom-button
            (clickBtn)="messageAmount = componentCase.messages?.length"
            [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
            [size]="ButtonSize.MEDIUM"
            [mode]="ButtonMode.INLINE"
            [text]="
              'SERVICE_FORMS.CSServiceForms.retrieveFeedback.chatter.showMore'
                | finLocalization: { count: componentCase.messages.length - (messageAmount - 1) }
            "
          >
          </fcom-button>
        </div>
      </div>
    </div>
    <fin-chatter
      class="block border-top"
      [caseResponse]="componentCase"
      (caseMessage)="handleNewMessage($event)"
    ></fin-chatter>
  </div>
</div>
